import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AirlineContent } from 'pages/promo-page/model.ts'

import { priceShow } from 'shared/lib/priceShow.ts'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { Button } from 'shared/ui/button'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  data: AirlineContent
  onSearch?: (data: AirlineContent) => void
}

export const DirectionCard = ({ data, onSearch }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <div className={s.info}>
        {data?.logo_url && (
          <ImageLazy
            src={data?.logo_url}
            className={s.icon}
          />
        )}

        <div className={s.text}>
          <div className={clsx(s.direction, 'semi-bold-14')}>
            {`${data?.from_city} → ${data?.to_city}`}
          </div>

          <div className={s.price}>
            <span className={clsx(s.newPrice, 'extra-bold-20')}>
              {t('price_som', { price: priceShow(data?.price) })}
            </span>
            {data?.old_price && (
              <span className={clsx(s.oldPrice, 'semi-bold-12')}>
                {t('price_som', { price: priceShow(data?.old_price) })}
              </span>
            )}
          </div>
        </div>
      </div>

      <Button
        className={s.button}
        onClick={() => onSearch?.(data)}
      >
        {t('buy')}
        <AppIcon
          id={AllIcons.ARROW_RIGHT_SMALL}
          width={10}
          height={10}
        />
      </Button>
    </div>
  )
}
